export default {
  PUBLISH_WEBSITE: '@YOLA_EDITOR/PUBLISH_WEBSITE',
  UNPUBLISH_WEBSITE: '@YOLA_EDITOR/UNPUBLISH_WEBSITE',
  FINISH_PUBLISHING: '@YOLA_EDITOR/FINISH_PUBLISHING',
  SET_PUBLISHING_SERVICE_CONFIG: '@YOLA_EDITOR/SET_PUBLISHING_SERVICE_CONFIG',
  SET_PUBLISHING_STATUS: '@YOLA_EDITOR/SET_PUBLISHING_STATUS',
};
